import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, FormControl, FormControlLabel, Radio, RadioGroup, Typography, } from '@mui/material';
import { useContext, useState } from 'react';
import { NewBookingContext } from '../NewBookingContext';
var DayEnum;
(function (DayEnum) {
    DayEnum[DayEnum["singleDay"] = 0] = "singleDay";
    DayEnum[DayEnum["multipleDay"] = 1] = "multipleDay";
})(DayEnum || (DayEnum = {}));
export const AddAbsenceNumberOfDaysPage = ({ setMultipleDays, isMultipleDays, }) => {
    const { updateState } = useContext(NewBookingContext);
    const [day, setDay] = useState(isMultipleDays === null
        ? null
        : isMultipleDays
            ? DayEnum.multipleDay
            : DayEnum.singleDay);
    const daySelection = () => {
        setDay(DayEnum.singleDay);
        setMultipleDays(false);
        updateState((state) => ({
            ...state,
            dateRange: { ...state.dateRange, endDate: state.dateRange.startDate },
        }));
    };
    const multipleDaySelection = () => {
        setDay(DayEnum.multipleDay);
        setMultipleDays(true);
    };
    return (_jsxs(Box, { p: 2, children: [_jsx(Box, { pb: 2, children: _jsx(Typography, { variant: 'body2', children: "How many days would you like to book?" }) }), _jsx(Box, { children: _jsx(FormControl, { size: 'small', children: _jsxs(RadioGroup, { children: [_jsx(FormControlLabel, { onClick: daySelection, value: DayEnum.singleDay, checked: day === DayEnum.singleDay, control: _jsx(Radio, {}), label: _jsx(Typography, { variant: 'subtitle1', children: "One day" }) }), _jsx(FormControlLabel, { onClick: multipleDaySelection, value: DayEnum.multipleDay, checked: day === DayEnum.multipleDay, control: _jsx(Radio, {}), label: _jsx(Typography, { variant: 'subtitle1', children: "Multiple days" }) })] }) }) })] }));
};
